<template>
  <section ref="yachtCollections" class="relative">
    <!-- Background Text Section -->
    <section
        class="intro-section flex justify-center items-center px-8 md:px-16 pt-48 pb-32 w-full responsive-title-3 text-center text-black bg-violet-200 relative"
    >
      <div class="relative mx-auto">
        <!-- Polaroid 1 -->
        <div
            ref="polaroidLeft"
            :class="[
            'flex flex-col items-center self-end px-2 pt-2 pb-11 sm:pb-14 bg-background-light rounded-md  mt-0 md:mt-10 absolute transition-all duration-1000 ease-in-out transform right-0 sm:right-14 top-16 md:top-3 opacity-0',
            { 'translate-y-[-270px] sm:translate-y-[-220px] xl:translate-y-[-220px] translate-x-[-160px] sm:translate-x-[-140px] xl:translate-x-[-40px] opacity-100 rotate-[-11deg]': animateLeft }
          ]"
        >
          <img
              loading="lazy"
              src="@/assets/about/founders/Frank_about_1.png"
              alt="Group Image 1"
              class="rounded-lg w-32 md:w-40 h-36 md:h-48 object-cover flex-shrink-0"
          />
        </div>
        <!-- Polaroid 2 -->
        <div
            ref="polaroidRight"
            :class="[
            'flex flex-col items-center self-end px-2 pt-2 pb-11 sm:pb-14 bg-background-light rounded-md mt-0 md:mt-10 absolute transition-all duration-1000 ease-in-out left-0 sm:left-9 opacity-0',
            { 'translate-y-[520px] sm:translate-y-[280px] xl:translate-y-[380px] translate-x-[10px] sm:translate-x-[80px] xl:translate-x-[50px] opacity-100 rotate-[15deg]': animateRight }
          ]"
        >
          <img
              loading="lazy"
              src="@/assets/about/founders/Harris_about.png"
              alt="Group Image 2"
              class="rounded-lg w-32 md:w-40 h-36 md:h-48 object-cover flex-shrink-0"
          />
        </div>

        <!-- Polaroid 3 -->
        <div
            ref="polaroidThird"
            :class="[
            'flex flex-col items-center self-end px-2 pt-2 pb-11 sm:pb-14 bg-background-light rounded-md mt-0 md:mt-10 absolute transition-all duration-1000 ease-in-out transform right-0 sm:right-24 top-10 opacity-0',
            { 'translate-y-[500px] sm:translate-y-[300px] xl:translate-y-[400px] translate-x-[-10px] sm:translate-x-[-350px] xl:translate-x-[-380px] opacity-100 rotate-[-3deg]': animateThird }
          ]"
        >
          <img
              loading="lazy"
              src="@/assets/about/founders/Nikolas_about.png"
              alt="Group Image 3"
              class="rounded-lg w-32 md:w-40 h-36 md:h-48 object-cover flex-shrink-0 "
          />
        </div>

        <!-- Polaroid 4 -->
        <div
            ref="polaroidFourth"
            :class="[
            'flex flex-col items-center self-end px-2 pt-2 pb-11 sm:pb-14 bg-background-light rounded-md mt-0 md:mt-10 absolute transition-all duration-1000 ease-in-out transform left-0 sm:left-24 top-18 md:top-0 opacity-0',
            { 'translate-y-[-250px] sm:translate-y-[-270px] xl:translate-y-[-270px] translate-x-[180px] sm:translate-x-[350px] xl:translate-x-[450px] opacity-100 rotate-[10deg]': animateFourth }
          ]"
        >
          <img
              loading="lazy"
              src="@/assets/about/founders/Jordanis_about.png"
              alt="Group Image 4"
              class="rounded-lg w-32 md:w-40 h-36 md:h-48 object-cover flex-shrink-0"
          />
        </div>

        <div class="max-w-[839px] mx-auto responsive-title-1">
          {{ $t('highlight.centralText') }}
        </div>
      </div>
    </section>
  </section>
</template>


<script>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
  name: "HighlightSection",
  setup() {
    const { t } = useI18n();
    const animateLeft = ref(false);
    const animateRight = ref(false);
    const animateThird = ref(false);
    const animateFourth = ref(false);

    const polaroidLeft = ref(null);
    const polaroidRight = ref(null);
    const polaroidThird = ref(null);
    const polaroidFourth = ref(null);

    onMounted(() => {
      const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (entry.target === polaroidLeft.value) animateLeft.value = true;
                if (entry.target === polaroidRight.value) animateRight.value = true;
                if (entry.target === polaroidThird.value) animateThird.value = true;
                if (entry.target === polaroidFourth.value) animateFourth.value = true;
                observer.unobserve(entry.target); // Stop observing after animation
              }
            });
          },
          { threshold: 0.5 } // Trigger when 50% of the section is visible
      );

      // Observe each polaroid image separately
      observer.observe(polaroidLeft.value);
      observer.observe(polaroidRight.value);
      observer.observe(polaroidThird.value);
      observer.observe(polaroidFourth.value);
    });

    return {
      animateLeft,
      animateRight,
      animateThird,
      animateFourth,
      polaroidLeft,
      polaroidRight,
      polaroidThird,
      polaroidFourth,
    };
  },
};
</script>




